import { Uppy } from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import ProgressBar from '@uppy/progress-bar';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import { each } from 'lodash';
import app from '../../angular_app.es6';

app.directive('imageUploader', [ '$timeout', 'Notification', ($timeout, Notification) => {
  return {
    restrict: 'A',
    scope: {
      image: '=imageUploader',
      imageField: '@',
      previewElement: '@',
      onInitCallback: '&',
      onFinishItemCallback: '&'
    },
    link: ($scope, $element) => {
      // private
      const imagePreview = document.getElementById($scope.previewElement);
      const fileInput = $element[0];

      const uppy = _fileUpload(fileInput);

      uppy
        .use(ThumbnailGenerator, {
          thumbnailWidth: 800
        })
        .use(ProgressBar, {
          target: imagePreview.parentNode
        });

      const _fileAdded = (file) => {
        uppy.upload();
        if ($scope.onInitCallback && $scope.onInitCallback()) {
          $scope.onInitCallback()(file);
        }
      };

      const _onUploadSuccess = function (file, response) {
        const uploadedFileData = _uploadedFileData(file);
        // set hidden field value to the uploaded file data so that it's submitted with the form as the attachment
        $timeout(() => {
          $scope.image[`${$scope.imageField}_data`] = uploadedFileData;

          if ($scope.onFinishItemCallback && $scope.onFinishItemCallback()) {
            $scope.onFinishItemCallback()(uploadedFileData);
          }
        });
      };

      const _onThumbnailGenerator = function (file, preview) {
        $timeout(() => {
          $scope.image[`${$scope.imageField}_src`] = preview;
        });
      };

      uppy.on('file-added', _fileAdded);
      uppy.on('upload-success', _onUploadSuccess);
      uppy.on('thumbnail:generated', _onThumbnailGenerator);

      function _fileUpload(fileInput) {
        const uppy = new Uppy();

        uppy.use(AwsS3, {
          endpoint: '/' // will call Shrine's presign endpoint mounted on `/s3/params`
        });

        fileInput.onchange = (event) => {
          const files = Array.from(event.target.files);
          if (!files.length) {
            return;
          }
          const resetFiles = () => {
            uppy.getState().files = {};
            uppy.getState().totalProgress = null;
          };
          resetFiles();
          fileInput.value = '';
          each(files, (file) => {
            uppy.addFile({
              source: 'file input',
              name: file.name,
              type: file.type,
              data: file
            });
          });
        };

        return uppy;
      }

      function _uploadedFileData(file, response) {
        // construct uploaded file data in the format that Shrine expects
        return JSON.stringify({
          id: file.s3Multipart['key'].match(/^cache\/(.+)/)[1], // object key without prefix
          storage: 'cache',
          metadata: {
            size: file.size,
            filename: file.name,
            mime_type: file.type
          }
        });
      }
    }
  };
} ]);
